import {
    GET_STORE_FILTER_SUCCESS,
    GET_STORE_SUCCESS,
} from '../actions/types';

const initialState = {
    array_store: [],
    store: '',
    current_page: 1,
    last_page: 1,
    array_filters: [],
};

export default function Store(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_STORE_SUCCESS:
            const newList =
                payload.stores.current_page === 1
                    ? payload.stores.data
                    : [...state.array_store, ...payload.stores.data];

            const unique = newList.filter(
                (item, index, self) => index === self.findIndex(t => t.id === item.id)
            );

            return {
                ...state,
                array_store: unique,
                current_page: payload.stores.current_page,
                last_page: payload.stores.last_page,
            };

        case GET_STORE_FILTER_SUCCESS:
            return {
                ...state,
                array_filters: payload.data.filters,
            }
        default:
            return state
    }
}


